import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { initStoreAndServices } from '../../config';
import { ReviewsContextProvider } from '../shared/context';
import FreelancerReviews from './FreelancerReviews';

export const FreelancerReviewsEntry = ({
    initialState,
    currencyConfig,
    onFilterChange,
    onLoadMoreClick,
    withLinkToGig,
    translationUrl,
    enableSearchFilter,
    enableReliableReviews,
    shouldAllocateForReliableReviews,
    reliableReviewsKillswitch,
    isReviewItemFullWidth,
}) => {
    const store = initStoreAndServices(initialState);
    return (
        <Provider store={store}>
            <ReviewsContextProvider
                initialState={initialState}
                currencyConfig={currencyConfig}
                withLinkToGig={withLinkToGig}
                translationUrl={translationUrl}
                enableSearchFilter={enableSearchFilter}
                enableReliableReviews={enableReliableReviews}
                shouldAllocateForReliableReviews={shouldAllocateForReliableReviews}
                reliableReviewsKillswitch={reliableReviewsKillswitch}
                isReviewItemFullWidth={isReviewItemFullWidth}
            >
                <FreelancerReviews onFilterChange={onFilterChange} onLoadMoreClick={onLoadMoreClick} />
            </ReviewsContextProvider>
        </Provider>
    );
};

FreelancerReviewsEntry.propTypes = {
    initialState: PropTypes.object.isRequired,
    currencyConfig: PropTypes.object.isRequired,
    onFilterChange: PropTypes.func,
    onLoadMoreClick: PropTypes.func,
    withLinkToGig: PropTypes.bool,
    translationUrl: PropTypes.string,
    enableSearchFilter: PropTypes.bool,
    enableReliableReviews: PropTypes.bool,
    isReviewItemFullWidth: PropTypes.bool,
};

FreelancerReviewsEntry.defaultProps = {
    withLinkToGig: true,
};

export default FreelancerReviewsEntry;
